export { default as SectionTabs } from "./SectionTabs";
